import { jsx as _jsx } from "react/jsx-runtime";
import { useBatchUpdateFormAssetsMutation } from "@air/feature-content-collection/hooks";
import { memo, useCallback, useMemo } from "react";
import { BoardCollectionCustomFieldsSelect } from "~/components/BoardCollection/CustomFields/BoardCollectionCustomFieldsSelect";
import { boardCollectionSessionIdSelector } from "~/store/boardCollection/selectors";
import { useAirStore } from "~/utils/ReduxUtils";
export const ContentCollectionCustomFieldMultiSelect = /*#__PURE__*/ memo((param)=>{
    let { clips, customField, disabled, onSuccess, values } = param;
    const store = useAirStore();
    const { mutate: batchUpdateFormAssets, isPending } = useBatchUpdateFormAssetsMutation();
    const customFieldWithValues = useMemo(()=>({
            ...customField,
            value: null,
            values: values !== null && values !== void 0 ? values : null
        }), [
        customField,
        values
    ]);
    const onSelectionChange = useCallback((param)=>{
        let { allValueIds, values } = param;
        const sessionId = boardCollectionSessionIdSelector(store.getState());
        if (!sessionId) {
            throw new Error("No session id");
        }
        /**
         * @TODO - Hacky this is a workaround to override the existing custom field values. Since the BE doesn't allow us to just pass in `valueIds`
         */ batchUpdateFormAssets({
            assetIds: Object.values(clips).map((param)=>{
                let { assetId } = param;
                return assetId;
            }),
            formSessionId: sessionId,
            update: {
                customFields: [
                    {
                        customFieldId: customField.id,
                        valueIdsToRemove: allValueIds
                    }
                ]
            }
        }, {
            onSuccess: ()=>{
                batchUpdateFormAssets({
                    assetIds: Object.values(clips).map((param)=>{
                        let { assetId } = param;
                        return assetId;
                    }),
                    formSessionId: sessionId,
                    update: {
                        customFields: [
                            {
                                customFieldId: customField.id,
                                valueIdsToAdd: values === null || values === void 0 ? void 0 : values.map((param)=>{
                                    let { id } = param;
                                    return id;
                                })
                            }
                        ]
                    }
                }, {
                    onSuccess: ()=>{
                        onSuccess({
                            customFieldWithValues,
                            values
                        });
                    }
                });
            }
        });
    }, [
        batchUpdateFormAssets,
        clips,
        customField.id,
        customFieldWithValues,
        onSuccess,
        store
    ]);
    return /*#__PURE__*/ _jsx(BoardCollectionCustomFieldsSelect, {
        disabled: disabled || isPending,
        clips: clips,
        field: customFieldWithValues,
        onSelectionChange: onSelectionChange
    });
});
ContentCollectionCustomFieldMultiSelect.displayName = "ContentCollectionCustomFieldMultiSelect";
